// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1935":"c9ee3f8f75d24b5a","2888":"e78612641514cc45","8455":"5e843e6648162e5b"}[chunkId] + ".css";
};